import React from "react"

import { createIcon } from "@chakra-ui/react"

export const SuccessIcon = createIcon({
  displayName: "SuccessIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <circle cx="12" cy="12" r="12" fill="fill" />
      <path
        fill={"currentColor"}
        d="M9.52495 17.657L4.57495 12.707L5.98895 11.293L9.52645 14.8265L9.52495 14.828L18.01 6.34299L19.424 7.75699L10.939 16.243L9.52595 17.656L9.52495 17.657Z"
      />
    </>
  ),
})
